import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { Type, Select } from '@nerdwallet/currency';
import { formInputChanged } from '@nerdwallet/nw-client-lib/tracking';

class SearchFacetFilter extends React.Component {
  static propTypes = {
    /**
     * All facets for the current search query
     */
    facets: PropTypes.object,
    /**
     * Facets currently selected
     */
    selectedFacets: PropTypes.object,
    onFacetChange: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {};

    this.onFacetChange = this.onFacetChange.bind(this);
  }

  onFacetChange(value, key, name) {
    const { onFacetChange, selectedFacets } = this.props;
    const checkedFacets = selectedFacets?.[key] ?? [];

    const newValues = _.difference(value, checkedFacets);
    const removedValues = _.difference(checkedFacets, value);
    const changedValue = _.concat(newValues, removedValues)?.[0] ?? ''; // there should only be one

    formInputChanged({
      formName: `searchFilter${_.camelCase(name)}`,
      fieldName: key,
      fieldValue: changedValue,
      inputType: 'CHECKBOX',
    });

    if (onFacetChange) {
      onFacetChange({
        key,
        value,
      });
    }
  }

  render() {
    const { facets = {}, selectedFacets = {} } = this.props;
    const getFacetItems = (key) => {
      if (facets[key] === undefined) {
        return [];
      }
      return _.map(facets[key], (bucket) => {
        const { value } = bucket;

        return {
          label: `${value}`,
          value,
        };
      });
    };
    const getSelectedFacetValues = (key) => selectedFacets?.[key] ?? [];

    const getFacetSelectProps = (label, key) => (
      <Select
        label={
          <Type size={1} bold uppercase light>
            {label}
          </Type>
        }
        id={key}
        options={getFacetItems(key)}
        onChange={(e) => this.onFacetChange(e.target.value, key, label)}
        value={getSelectedFacetValues(key)}
        block
        multiple
      />
    );

    return (
      <div className="search-facet-filter">
        <div className="facet-filter">
          {getFacetSelectProps('Financial topic', 'category')}
        </div>
        <div className="facet-filter">
          {getFacetSelectProps('Result type', 'content_type')}
        </div>
      </div>
    );
  }
}

export default SearchFacetFilter;
